"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuoteDataStore = void 0;
var Sentry = __importStar(require("@sentry/browser"));
var mobx_1 = require("mobx");
var zod_1 = require("zod");
var Types_1 = require("@CommonFrontendBackend/QuoteV2/Types");
var TaxService_1 = __importDefault(require("./TaxService"));
var CalculatorService_1 = __importDefault(require("./Calculator/CalculatorService"));
var CommonUtils_1 = require("@CommonFrontendBackend/Utils/CommonUtils");
var discountSchema = zod_1.z
    .union([
    zod_1.z.object({
        enabled: zod_1.z.boolean().catch(function (_a) {
            var input = _a.input;
            return !!input;
        }),
        id: zod_1.z.string(),
    }),
    zod_1.z.object({
        enabled: zod_1.z.boolean().catch(function (_a) {
            var input = _a.input;
            return !!input;
        }),
        type: zod_1.z.enum([Types_1.DiscountType.Percent, Types_1.DiscountType.Fixed]),
        units: zod_1.z.number().nullable(),
    }),
])
    .nullable()
    .default(null);
var contentModelSchema = zod_1.z
    .object({
    tokens: zod_1.z.array(zod_1.z.any()).default([]).optional(),
    content: zod_1.z.string().default(""),
    widgets: zod_1.z.any().optional(),
})
    .default({ tokens: [], content: "" });
var interactiveSchema = zod_1.z
    .object({
    isOptional: zod_1.z
        .boolean()
        .default(false)
        .catch(function (_a) {
        var input = _a.input;
        return !!input;
    }),
    isOptionalSelected: zod_1.z
        .boolean()
        .default(false)
        .catch(function (_a) {
        var input = _a.input;
        return !!input;
    }),
})
    .optional();
var billingScheduleSchema = zod_1.z
    .discriminatedUnion("type", [
    zod_1.z.object({ type: zod_1.z.literal(Types_1.BillingScheduleType.OneOff) }),
    zod_1.z.object({
        type: zod_1.z.literal(Types_1.BillingScheduleType.Recurring),
        frequency: zod_1.z.enum([
            Types_1.RecurringFrequency.Weekly,
            Types_1.RecurringFrequency.Fortnightly,
            Types_1.RecurringFrequency.Monthly,
            Types_1.RecurringFrequency.Quarterly,
            Types_1.RecurringFrequency.SemiAnnually,
            Types_1.RecurringFrequency.Yearly,
            Types_1.RecurringFrequency.TwoYearly,
            Types_1.RecurringFrequency.ThreeYearly,
        ]),
    }),
])
    .optional();
var partialItemsSchema = zod_1.z.discriminatedUnion("type", [
    zod_1.z.object({
        type: zod_1.z.literal(Types_1.QuoteItemType.FixedCost),
        description: contentModelSchema,
        quantity: zod_1.z.number().default(0),
        rate: zod_1.z.object({ rate: zod_1.z.number(), unit: zod_1.z.string() }),
        interactive: interactiveSchema,
        billingSchedule: billingScheduleSchema,
        discount: discountSchema,
        isTaxExempt: zod_1.z
            .boolean()
            .default(false)
            .catch(function (_a) {
            var input = _a.input;
            return !!input;
        }),
        featureList: contentModelSchema,
    }),
    zod_1.z.object({
        type: zod_1.z.literal(Types_1.QuoteItemType.Variable),
        description: contentModelSchema,
        quantity: zod_1.z.number().default(0),
        rate: zod_1.z.object({ variableId: zod_1.z.string().optional() }).nullable(),
        interactive: interactiveSchema,
        billingSchedule: billingScheduleSchema,
        discount: discountSchema,
        isTaxExempt: zod_1.z
            .boolean()
            .default(false)
            .catch(function (_a) {
            var input = _a.input;
            return !!input;
        }),
        featureList: contentModelSchema,
    }),
    zod_1.z.object({
        type: zod_1.z.literal(Types_1.QuoteItemType.Text),
        description: contentModelSchema,
        interactive: interactiveSchema,
    }),
    zod_1.z.object({
        type: zod_1.z.literal(Types_1.QuoteItemType.Product),
        description: contentModelSchema,
        interactive: interactiveSchema,
        isTaxExempt: zod_1.z
            .boolean()
            .optional()
            .catch(function (_a) {
            var input = _a.input;
            return !!input;
        }),
    }),
]);
var partialSectionSchema = zod_1.z.object({
    description: contentModelSchema,
    items: zod_1.z.array(partialItemsSchema).default([]),
    displayMode: zod_1.z
        .enum([Types_1.QuoteSectionDisplayMode.Table, Types_1.QuoteSectionDisplayMode.PlanCards])
        .default(Types_1.QuoteSectionDisplayMode.Table),
    mandatory: zod_1.z
        .boolean()
        .optional()
        .catch(function (ctx) { return !!ctx.input; }),
    selected: zod_1.z
        .boolean()
        .optional()
        .catch(function (ctx) { return !!ctx.input; }),
    discount: discountSchema,
    viewSettings: zod_1.z
        .object({
        itemsViewable: zod_1.z
            .boolean()
            .default(true)
            .catch(function (_a) {
            var input = _a.input;
            return !!input;
        }),
        showRateAndQuantity: zod_1.z
            .boolean()
            .default(true)
            .catch(function (_a) {
            var input = _a.input;
            return !!input;
        }),
        showRate: zod_1.z
            .boolean()
            .optional()
            .catch(function (_a) {
            var input = _a.input;
            return !!input;
        }),
        showQuantity: zod_1.z
            .boolean()
            .optional()
            .catch(function (_a) {
            var input = _a.input;
            return !!input;
        }),
        showCost: zod_1.z
            .boolean()
            .default(true)
            .catch(function (_a) {
            var input = _a.input;
            return !!input;
        }),
        showSubtotal: zod_1.z
            .boolean()
            .default(false)
            .catch(function (_a) {
            var input = _a.input;
            return !!input;
        }),
    })
        .default({ showCost: true, showRate: true, showQuantity: true, itemsViewable: true, showSubtotal: false }),
});
var partialQuoteSchema = zod_1.z.object({
    contentAreas: zod_1.z.object({ header: contentModelSchema }).optional(),
    selectionType: zod_1.z
        .enum([Types_1.QuoteSelectionType.Combined, Types_1.QuoteSelectionType.Multi, Types_1.QuoteSelectionType.Single])
        .default(Types_1.QuoteSelectionType.Combined)
        .catch(Types_1.QuoteSelectionType.Combined),
    sections: zod_1.z
        .array(partialSectionSchema)
        .default([]),
    discount: discountSchema,
    settings: zod_1.z
        .object({
        view: zod_1.z
            .object({
            showDecimalPlaces: zod_1.z
                .boolean()
                .default(true)
                .catch(function (_a) {
                var input = _a.input;
                return !!input;
            }),
            showTotalDiscount: zod_1.z
                .boolean()
                .default(false)
                .catch(function (_a) {
                var input = _a.input;
                return !!input;
            }),
            showSubtotal: zod_1.z
                .boolean()
                .default(false)
                .catch(function (_a) {
                var input = _a.input;
                return !!input;
            }),
            showTaxTotals: zod_1.z
                .boolean()
                .default(false)
                .catch(function (_a) {
                var input = _a.input;
                return !!input;
            }),
            showExTax: zod_1.z
                .boolean()
                .default(false)
                .catch(function (_a) {
                var input = _a.input;
                return !!input;
            }),
            showQuoteTotals: zod_1.z
                .boolean()
                .default(true)
                .catch(function (_a) {
                var input = _a.input;
                return !!input;
            }),
        })
            .default({
            showDecimalPlaces: true,
            showTotalDiscount: false,
            showSubtotal: false,
            showTaxTotals: false,
            showExTax: false,
            showQuoteTotals: true,
        }),
        labelSetId: zod_1.z.string().optional(),
        currency: zod_1.z.string().optional(),
        enabledTaxes: zod_1.z.record(zod_1.z.string(), zod_1.z.any()).optional(),
    })
        .default({ view: { showDecimalPlaces: true } }),
    includeRecurringInDueToday: zod_1.z
        .boolean()
        .optional()
        .catch(function (_a) {
        var input = _a.input;
        return !!input;
    }),
});
var cachedQuotesSchema = zod_1.z.array(partialQuoteSchema);
var QuoteDataStore = (function () {
    function QuoteDataStore($rootScope, quoteBlocksList, projectTotal, variableService, labelService, projectCurrencies, billingScheduleOrchestrator, discountService, accountQuoteSettings) {
        var _this = this;
        this.$rootScope = $rootScope;
        this.quoteBlocksList = quoteBlocksList;
        this.projectTotal = projectTotal;
        this.variableService = variableService;
        this.labelService = labelService;
        this.projectCurrencies = projectCurrencies;
        this.billingScheduleOrchestrator = billingScheduleOrchestrator;
        this.discountService = discountService;
        this.accountQuoteSettings = accountQuoteSettings;
        this._quoteBlocks = [];
        this.convertDiscount = function (discount) {
            if ((0, Types_1.isQuoteFixedDiscount)(discount)) {
                return discount;
            }
            if ((0, Types_1.isQuoteVariableDiscount)(discount)) {
                var savedDiscount = _this.discountService.findDiscountById(discount.id);
                return {
                    enabled: discount.enabled,
                    type: savedDiscount.type,
                    units: savedDiscount.amount,
                };
            }
            return null;
        };
        this.getLabel = function (labelSetId, label) {
            return _this.labelService.getLabel(labelSetId, label);
        };
        var taxService = new TaxService_1.default(this.accountQuoteSettings.taxes);
        this.calculatorService = new CalculatorService_1.default(taxService, this.variableService, this.discountService, this.billingScheduleOrchestrator);
        var deregisterWatch = this.$rootScope.$watch(function () {
            try {
                var quoteBlocks = _this.quoteBlocksList.get();
                return cachedQuotesSchema.parse(quoteBlocks);
            }
            catch (error) {
                console.error("Error parsing QuoteDataStore schema on project quote block list", error);
                Sentry.captureException(new Error("Error parsing QuoteDataStore schema on project quote block list"), {
                    extra: {
                        error: error,
                    },
                });
                deregisterWatch();
            }
        }, function (incomingQuoteBlocks) {
            if (incomingQuoteBlocks) {
                _this._quoteBlocks = incomingQuoteBlocks;
            }
        }, true);
    }
    Object.defineProperty(QuoteDataStore.prototype, "selectedQuoteItems", {
        get: function () {
            var _this = this;
            return this._quoteBlocks.map(function (quote) { return ({
                contentAreas: quote.contentAreas,
                labelSetId: quote.settings.labelSetId,
                total: _this.calculatorService.calculateQuote(quote),
                discount: _this.convertDiscount(quote.discount),
                viewSettings: {
                    showTotalDiscount: quote.settings.view.showTotalDiscount,
                    showSubtotal: quote.settings.view.showSubtotal,
                    showTaxTotals: quote.settings.view.showTaxTotals,
                    showExTax: quote.settings.view.showExTax,
                    showQuoteTotals: quote.settings.view.showQuoteTotals,
                },
                sections: quote.sections
                    .filter(function (section) {
                    if (section === undefined) {
                        return false;
                    }
                    if (quote.selectionType === Types_1.QuoteSelectionType.Combined) {
                        return true;
                    }
                    return section.mandatory || section.selected;
                })
                    .map(function (section) {
                    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
                    return ({
                        displayMode: (_a = section.displayMode) !== null && _a !== void 0 ? _a : Types_1.QuoteSectionDisplayMode.Table,
                        description: section.description,
                        total: _this.calculatorService.calculateSection(section, _this.currency),
                        discount: _this.convertDiscount(section.discount),
                        items: section.items
                            .filter(function (item) {
                            if (item.type === Types_1.QuoteItemType.Product) {
                                return false;
                            }
                            if (item.interactive && item.interactive.isOptional) {
                                return item.interactive.isOptionalSelected;
                            }
                            return true;
                        })
                            .map(function (item) {
                            var _a, _b, _c, _d, _e, _f, _g, _h;
                            if (item.type === Types_1.QuoteItemType.Variable) {
                                return {
                                    description: item.description,
                                    type: item.type,
                                    interactive: item.interactive,
                                    quantity: !!item.quantity ? item.quantity : 0,
                                    rate: {
                                        rate: ((_a = item.rate) === null || _a === void 0 ? void 0 : _a.variableId)
                                            ? (_d = (_c = _this.variableService.getVariable((_b = item.rate) === null || _b === void 0 ? void 0 : _b.variableId)) === null || _c === void 0 ? void 0 : _c.defaultAmount) !== null && _d !== void 0 ? _d : 0
                                            : 0,
                                        unit: ((_e = item.rate) === null || _e === void 0 ? void 0 : _e.variableId)
                                            ? (_h = (_g = _this.variableService.getVariable((_f = item.rate) === null || _f === void 0 ? void 0 : _f.variableId)) === null || _g === void 0 ? void 0 : _g.unitName) !== null && _h !== void 0 ? _h : "Unit"
                                            : "Unit",
                                    },
                                    discount: _this.convertDiscount(item.discount),
                                    billingSchedule: item.billingSchedule,
                                    isTaxExempt: item.isTaxExempt,
                                    total: _this.calculatorService.calculateItem(item, _this.currency),
                                    featureList: item.featureList,
                                };
                            }
                            if (item.type === Types_1.QuoteItemType.FixedCost) {
                                return {
                                    description: item.description,
                                    type: item.type,
                                    interactive: item.interactive,
                                    quantity: !!item.quantity ? item.quantity : 0,
                                    rate: { rate: item.rate.rate, unit: item.rate.unit },
                                    discount: _this.convertDiscount(item.discount),
                                    billingSchedule: item.billingSchedule,
                                    isTaxExempt: item.isTaxExempt,
                                    total: _this.calculatorService.calculateItem(item, _this.currency),
                                    featureList: item.featureList,
                                };
                            }
                            return {
                                description: item.description,
                                type: item.type,
                                interactive: item.interactive,
                            };
                        }),
                        viewSettings: {
                            showItemDescription: (_c = (_b = section.viewSettings) === null || _b === void 0 ? void 0 : _b.itemsViewable) !== null && _c !== void 0 ? _c : true,
                            showItemRate: (_f = (_e = (_d = section.viewSettings) === null || _d === void 0 ? void 0 : _d.showRate) !== null && _e !== void 0 ? _e : section.viewSettings.showRateAndQuantity) !== null && _f !== void 0 ? _f : true,
                            showItemQuantity: (_j = (_h = (_g = section.viewSettings) === null || _g === void 0 ? void 0 : _g.showQuantity) !== null && _h !== void 0 ? _h : section.viewSettings.showRateAndQuantity) !== null && _j !== void 0 ? _j : true,
                            showItemTotal: (_l = (_k = section.viewSettings) === null || _k === void 0 ? void 0 : _k.showCost) !== null && _l !== void 0 ? _l : true,
                            showItemSubtotal: (_o = (_m = section.viewSettings) === null || _m === void 0 ? void 0 : _m.showSubtotal) !== null && _o !== void 0 ? _o : false,
                        },
                    });
                }),
            }); });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuoteDataStore.prototype, "pageTotalPayToday", {
        get: function () {
            return this.projectTotal.calculatePayTodaySingleCurrency();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuoteDataStore.prototype, "pageTotal", {
        get: function () {
            return this.projectTotal.calculateProject();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuoteDataStore.prototype, "quoteBlockCount", {
        get: function () {
            return this._quoteBlocks.length;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuoteDataStore.prototype, "showDecimals", {
        get: function () {
            return this._quoteBlocks.some(function (block) { return block.settings.view.showDecimalPlaces; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuoteDataStore.prototype, "hasMultipleCurrencies", {
        get: function () {
            return this.projectCurrencies.hasMultipleCurrencies();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuoteDataStore.prototype, "currency", {
        get: function () {
            try {
                return this.projectCurrencies.getSingleCurrency();
            }
            catch (error) {
                return "AUD";
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuoteDataStore.prototype, "configuredQuotes", {
        get: function () {
            return this.quoteBlocksList.getWithBlockIds().map(function (_a) {
                var quoteBlock = _a.quoteBlock, id = _a.id;
                return {
                    originBlockId: id,
                    sections: quoteBlock.sections.map(function (section) {
                        return {
                            selected: section.selected,
                            items: section.items.map(function (item) {
                                var _a, _b;
                                switch (item.type) {
                                    case Types_1.QuoteItemType.FixedCost:
                                        return __assign(__assign({}, (0, CommonUtils_1.includeIf)(item.hasOwnProperty("quantity"), { quantity: item.quantity })), (0, CommonUtils_1.includeIf)(!!item.interactive && item.interactive.hasOwnProperty("isOptionalSelected"), {
                                            interactive: { isOptionalSelected: (_a = item === null || item === void 0 ? void 0 : item.interactive) === null || _a === void 0 ? void 0 : _a.isOptionalSelected },
                                        }));
                                    case Types_1.QuoteItemType.Variable:
                                        return __assign(__assign({}, (0, CommonUtils_1.includeIf)(item.hasOwnProperty("quantity"), { quantity: item.quantity })), (0, CommonUtils_1.includeIf)(!!item.interactive && item.interactive.hasOwnProperty("isOptionalSelected"), {
                                            interactive: { isOptionalSelected: (_b = item === null || item === void 0 ? void 0 : item.interactive) === null || _b === void 0 ? void 0 : _b.isOptionalSelected },
                                        }));
                                    default:
                                        return __assign({}, (0, CommonUtils_1.includeIf)(item.interactive.hasOwnProperty("isOptionalSelected"), {
                                            interactive: { isOptionalSelected: item.interactive.isOptionalSelected },
                                        }));
                                }
                            }),
                        };
                    }),
                };
            });
        },
        enumerable: false,
        configurable: true
    });
    var _a;
    __decorate([
        mobx_1.observable,
        __metadata("design:type", typeof (_a = typeof zod_1.z !== "undefined" && zod_1.z.infer) === "function" ? _a : Object)
    ], QuoteDataStore.prototype, "_quoteBlocks", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [])
    ], QuoteDataStore.prototype, "selectedQuoteItems", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [])
    ], QuoteDataStore.prototype, "quoteBlockCount", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], QuoteDataStore.prototype, "showDecimals", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], QuoteDataStore.prototype, "configuredQuotes", null);
    return QuoteDataStore;
}());
exports.QuoteDataStore = QuoteDataStore;
